import { createReactComponent } from "@tabler/icons-react";
import { svgToIconNode } from "shared/utils/icon";
import IconIpawsRaw from "src/assets/ipaws-icon.svg?raw";

export const IconIpaws = createReactComponent("filled", "ipaws", "Ipaws", svgToIconNode(IconIpawsRaw));
